import { API_BASE, API_URL } from "@/constants";
import { ProductsResponse } from "@/types/api/products";
import { getApiError } from "@/utils/api-error";

export const PRODUCTS_QUERY_KEY = "products";

export async function fetchProducts(category, country = "NO") {
  const numberOfProductsToRequest = 50;

  const response = await fetch(
    `${API_URL}${API_BASE}/allproducts?pageSize=${numberOfProductsToRequest}&shop_locale=${country}`
  );
  if (!response.ok) {
    throw await getApiError(response);
  }
  return response.json() as Promise<ProductsResponse>;
}
